module.exports = ".header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 50px; }\n  .header h1 {\n    margin: 0; }\n  .dropDown {\n  margin-bottom: 20px; }\n  .dropDown.select {\n    width: 50rem; }\n  .noResult {\n  width: 100%;\n  text-align: center; }\n  .listTable {\n  word-break: break-all;\n  word-wrap: break-word; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/progress/list/list.component.scss
// module id = ./src/app/modules/progress/list/list.component.scss
// module chunks = main